/* eslint-disable */
import AllSpecifications from 'containers/Specifications/AllSpecifications';
import Filters from 'containers/Specifications/Filters/Filters';
import FolderCreator from 'containers/Specifications/FolderCreator/FolderCreator';
import FolderView from 'containers/Specifications/FolderView';
import Breadcrumbs from 'layout/atoms/Breadcrumbs/Breadcrumbs';
import Grid from 'layout/molecules/Grid/Grid';
import Sticky from 'layout/molecules/Sticky';
import React, { memo, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { fetchRootFolder, fetchRootFolders, selectFolderName, selectFoldersTree, selectRootFolder, } from 'store/specificationsFoldersSlice';
const SpecificationsPicker = () => {
    var _a, _b, _c;
    const { t, i18n } = useTranslation(['specification', 'common', 'orders']);
    const dispatch = useDispatch();
    const location = useLocation();
    const layout = useSelector((state) => state.layout);
    const rootFolder = useSelector(selectRootFolder);
    const { orderId } = useParams();
    const url = `/orders/creator/${orderId}/specifications`;
    const isMyFiles = location.pathname === `${url}/my-files`;
    const isLatest = location.pathname === `${url}/latest`;
    const isDrafts = location.pathname === `${url}/drafts`;
    const isFolderView = location.pathname.includes(`${url}/folders/`);
    const folderId = ((_a = location.pathname.match(/folders\/([^/]+)/)) === null || _a === void 0 ? void 0 : _a[1]) || (rootFolder === null || rootFolder === void 0 ? void 0 : rootFolder.rootFolderId);
    const folderName = useSelector((state) => selectFolderName(state, folderId));
    const foldersTree = useSelector(selectFoldersTree);
    const memoFoldersTree = useMemo(() => foldersTree, [foldersTree]);
    useEffect(() => {
        dispatch(fetchRootFolder());
    }, [dispatch]);
    useEffect(() => {
        if (rootFolder.rootFolderId !== null) {
            dispatch(fetchRootFolders({ folderId: rootFolder.rootFolderId }));
        }
    }, [dispatch, rootFolder.status, rootFolder.rootFolderId]);
    const generateBreadcrumbs = (folders, currentFolderId) => {
        const breadcrumbs = [];
        let currentFolder = folders.find((folder) => folder.id === currentFolderId);
        while (currentFolder) {
            breadcrumbs.unshift({
                id: currentFolder.id,
                to: `${url}/folders/${currentFolder.id}`,
                name: currentFolder.name,
            });
            currentFolder = folders.find((folder) => folder.id === currentFolder.parentId);
        }
        return breadcrumbs;
    };
    const folderBreadcrumbs = memoFoldersTree ? generateBreadcrumbs(memoFoldersTree, folderId) : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { vp: 12, hp: 24, gap: 0 }, isMyFiles ? (React.createElement(React.Fragment, null,
            React.createElement(Breadcrumbs, { items: [
                    {
                        id: 'specifications/',
                        to: url,
                        name: t('specification_capitalize_other'),
                    },
                    { id: 'my_files', to: `${url}/my-files`, name: t('my_files') },
                ] }),
            React.createElement("h2", null, t('my_files')))) : isFolderView ? (React.createElement(React.Fragment, null,
            React.createElement(Breadcrumbs, { items: [
                    {
                        id: '/specifications/',
                        to: url,
                        name: t('specification_capitalize_other'),
                    },
                    ...folderBreadcrumbs,
                ] }),
            React.createElement("h2", null, folderId === rootFolder.rootFolderId ? t('all_folders') : folderName))) : null),
        React.createElement(Sticky, { shadow: true }, isMyFiles ? React.createElement(Filters, null) : isFolderView ? React.createElement(Filters, { folders: true }) : null),
        React.createElement(Grid, { vp: 12, hp: 24 },
            isMyFiles ? (React.createElement(AllSpecifications, { orderSelect: true })) : isLatest ? (React.createElement(AllSpecifications, { orderSelect: true, latest: true })) : isDrafts ? (React.createElement(AllSpecifications, { orderSelect: true, drafts: true })) : isFolderView ? (React.createElement(FolderView, { link: `${url}/folders`, orderSelect: true, folderId: folderId })) : ((rootFolder === null || rootFolder === void 0 ? void 0 : rootFolder.rootFolderId) && (React.createElement(Navigate, { to: `${url}/folders/${rootFolder === null || rootFolder === void 0 ? void 0 : rootFolder.rootFolderId}`, replace: true }))),
            ((_b = layout.showModals) === null || _b === void 0 ? void 0 : _b.some((modal) => modal.name === 'folderCreator')) && (React.createElement(FolderCreator, { parentFolder: folderId })),
            ((_c = layout.showModals) === null || _c === void 0 ? void 0 : _c.some((modal) => modal.name === 'folderEditor')) && (React.createElement(FolderCreator, { edit: true })))));
};
export default memo(SpecificationsPicker);
